import { IOfferAddressProps } from '../../components/OfferCard/Address';
import { IOfferAddress } from '../../types/offers';

export const getAddress = (address: IOfferAddress, isLast: boolean): IOfferAddressProps => ({
  id: address.id ?? undefined,
  title: `${address.title}${isLast ? '' : ',\u00A0'}`,
  searchUrl: address.qs ? `https://cian.ru/cat.php?${address.qs}` : '',
});
